/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest,
  SubscribeApiV1WebpushNotificationsSubscribePostMutationResponse,
  SubscribeApiV1WebpushNotificationsSubscribePostHeaderParams,
  SubscribeApiV1WebpushNotificationsSubscribePost422,
} from '../../types/SubscribeApiV1WebpushNotificationsSubscribePost.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const subscribeApiV1WebpushNotificationsSubscribePostMutationKey = () => [{ url: '/api/v1/webpush_notifications/subscribe' }] as const

export type SubscribeApiV1WebpushNotificationsSubscribePostMutationKey = ReturnType<typeof subscribeApiV1WebpushNotificationsSubscribePostMutationKey>

/**
 * @summary Subscribe
 * {@link /api/v1/webpush_notifications/subscribe}
 */
export async function subscribeApiV1WebpushNotificationsSubscribePost(
  data: SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest,
  headers?: SubscribeApiV1WebpushNotificationsSubscribePostHeaderParams,
  config: Partial<RequestConfig<SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    SubscribeApiV1WebpushNotificationsSubscribePostMutationResponse,
    ResponseErrorConfig<SubscribeApiV1WebpushNotificationsSubscribePost422>,
    SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest
  >({ method: 'POST', url: `/api/v1/webpush_notifications/subscribe`, data: requestData, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

/**
 * @summary Subscribe
 * {@link /api/v1/webpush_notifications/subscribe}
 */
export function useSubscribeApiV1WebpushNotificationsSubscribePost<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubscribeApiV1WebpushNotificationsSubscribePostMutationResponse,
      ResponseErrorConfig<SubscribeApiV1WebpushNotificationsSubscribePost422>,
      { data: SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest; headers?: SubscribeApiV1WebpushNotificationsSubscribePostHeaderParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? subscribeApiV1WebpushNotificationsSubscribePostMutationKey()

  return useMutation<
    SubscribeApiV1WebpushNotificationsSubscribePostMutationResponse,
    ResponseErrorConfig<SubscribeApiV1WebpushNotificationsSubscribePost422>,
    { data: SubscribeApiV1WebpushNotificationsSubscribePostMutationRequest; headers?: SubscribeApiV1WebpushNotificationsSubscribePostHeaderParams },
    TContext
  >(
    {
      mutationFn: async ({ data, headers }) => {
        return subscribeApiV1WebpushNotificationsSubscribePost(data, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}